import { injector } from '@asd-stan/injector/injector';

import { WGRepo } from '../api/working-group.repo';
import { WGService } from '../domain/wg.service';

import { WG_REPO, WG_SERVICE } from './constants';

export const getWgRepo = () => injector.get<WGRepo>(WG_REPO);
export const getWgService = () => injector.get<WGService>(WG_SERVICE);
